import { FILTER_DEPENDENCIES } from '../constants/filterDependencies';
import type { Filter, FilterId } from '../types/filters';
import type { FilterConsistencyState } from './filterGroupConsistency';
import { getFilterDefinition } from './filterRegistry';

export const processFilterDependencies = (
  currentState: FilterConsistencyState,
  triggerFilterId: FilterId,
  triggerFilterState: Filter
): FilterConsistencyState => {
  const dependencies = FILTER_DEPENDENCIES.get(triggerFilterId);
  if (!dependencies || !currentState.activeKey) {
    return currentState;
  }

  const currentActiveMap = currentState.groupMap.get(currentState.activeKey);
  if (!currentActiveMap) {
    return currentState;
  }

  const nextActiveMap = new Map(currentActiveMap);
  let mapChanged = false;

  for (const dep of dependencies) {
    const currentDependentFilterState = nextActiveMap.get(
      dep.dependentFilterId
    );
    const updatePayload = dep.transformer(
      triggerFilterState,
      currentDependentFilterState,
      nextActiveMap
    );

    if (updatePayload) {
      const existingDepFilter = nextActiveMap.get(dep.dependentFilterId);
      const updatedDepFilter = {
        ...(existingDepFilter || getFilterDefinition(dep.dependentFilterId)),
        ...updatePayload,
      } as Filter;

      nextActiveMap.set(dep.dependentFilterId, updatedDepFilter);
      mapChanged = true;
    }
  }

  if (mapChanged) {
    const newConsistencyMap = new Map(currentState.groupMap);
    newConsistencyMap.set(currentState.activeKey, nextActiveMap);

    return { ...currentState, groupMap: newConsistencyMap };
  }

  return currentState;
};
